
import { Form , Field, ChildForm } from '../form/form';
import { FormData } from '../form/formData';
import { SelectOption, Vo } from '../form/types';
import { Validators } from '@angular/forms'
import { ServiceAgent} from '../form/serviceAgent';

export class AssignChallengeReviewerForm extends Form {
	private static _instance = new AssignChallengeReviewerForm();
	departmentId:Field = {
		name:'departmentId'
		,controlType: 'Dropdown'
		,label: 'Select a Department'
		,isRequired: true
		,listName: 'departmentList'
		,valueType: 1
		,errorId: 'invalidId'
		,maxValue: 9999999999999
	};
	offeredSubjectId:Field = {
		name:'offeredSubjectId'
		,controlType: 'Dropdown'
		,label: 'Select a Subject'
		,isRequired: true
		,listName: 'offeredSubjectList'
		,listKey: 'departmentId'
		,valueType: 1
		,errorId: 'invalidId'
		,maxValue: 9999999999999
	};
	packetCode:Field = {
		name:'packetCode'
		,controlType: 'Dropdown'
		,label: 'Select a Packet'
		,isRequired: true
		,listName: 'challengePapersList'
		,listKey: 'offeredSubjectId'
		,valueType: 0
		,errorId: 'invalidText'
		,maxLength: 1000
	};

	public static getInstance(): AssignChallengeReviewerForm {
		return AssignChallengeReviewerForm._instance;
	}

	constructor() {
		super();
		this.fields = new Map();
		this.controls = new Map();
		this.controls.set('departmentId', [Validators.required, Validators.max(9999999999999)]);
		this.fields.set('departmentId', this.departmentId);
		this.controls.set('offeredSubjectId', [Validators.required, Validators.max(9999999999999)]);
		this.fields.set('offeredSubjectId', this.offeredSubjectId);
		this.controls.set('packetCode', [Validators.required, Validators.maxLength(1000)]);
		this.fields.set('packetCode', this.packetCode);
		this.opsAllowed = {filter: true, get: true};
		this.listFields = ['departmentId','offeredSubjectId','packetCode'];
	}

	public getName(): string {
		 return 'assignChallengeReviewer';
	}
}


export class AssignChallengeReviewerFd extends FormData {
	constructor(form: AssignChallengeReviewerForm, sa: ServiceAgent) {
		super(form, sa);
	}

	setFieldValue(name: 'departmentId' | 'offeredSubjectId' | 'packetCode', value: string | number | boolean | null ): void {
		super.setFieldValue(name, value);
	}

	getFieldValue(name: 'departmentId' | 'offeredSubjectId' | 'packetCode' ): string | number | boolean | null {
		return super.getFieldValue(name);
	}
}


export interface AssignChallengeReviewerVo extends Vo {
	offeredSubjectId?: number, 
	departmentId?: number, 
	packetCode?: string
}
